import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { NIGHT_EYE_API_URL } from "../Process";
import axiosInstance from "./AxiosInstance";



export const useUserRegistration = () => {
    return useMutation({
        mutationFn: async (payload) => {
            const API_URL = `${NIGHT_EYE_API_URL}user/userRegistrationWithMobileNo`;
            const { data } = await axios.post(API_URL, payload, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            return data;
        },
    });
};
export const useAddUser = () => {
    return useMutation({
        mutationFn: async (payload) => {
            const API_URL = `${NIGHT_EYE_API_URL}user/setUser`;

            // ✅ If payload is already FormData, send directly
            let formData;
            if (payload instanceof FormData) {
                formData = payload;
            } else {
                // Otherwise build a FormData object
                formData = new FormData();
                Object.entries(payload).forEach(([key, value]) => {
                    if (value !== null && value !== undefined) {
                        if (typeof value === "object" && !(value instanceof File)) {
                            formData.append(key, JSON.stringify(value)); // serialize objects/arrays
                        } else {
                            formData.append(key, value);
                        }
                    }
                });
            }

            const { data } = await axiosInstance.post(API_URL, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return data;
        },
    });
};

export const useMainDepartmentUserLogin = () => {
    return useMutation({
        mutationFn: async (payload) => {
            const API_URL = `${NIGHT_EYE_API_URL}user/setUserDepartmentLoginWithMobileNo`;
            const { data } = await axios.post(API_URL, payload, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            return data;
        },
    });
};
export const useMainVendorUserLogin = () => {
    return useMutation({
        mutationFn: async (payload) => {
            const API_URL = `${NIGHT_EYE_API_URL}user/setUserVendorLoginWithMobileNo`;
            const { data } = await axios.post(API_URL, payload, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            return data;
        },
    });
};
export const useDepartmentLogin = () => {
    return useMutation({
        mutationFn: async (payload) => {
            const API_URL = `${NIGHT_EYE_API_URL}user/setUserLogin`;
            const { data } = await axios.post(API_URL, payload, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            return data;
        },
    });
};

export const useVerifyOTP = () => {
    return useMutation({
        mutationFn: async (payload) => {
            const API_URL = `${NIGHT_EYE_API_URL}user/setUserVerifyLoginOTP`;
            const { data } = await axios.post(API_URL, payload, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            return data;
        },
    });
};
export const useShopIsActiveStatus = () => {
    return useMutation({
        mutationFn: async (payload) => {
            const API_URL = `${NIGHT_EYE_API_URL}shop/setShopIsActiveStatus`;
            const { data } = await axiosInstance.post(API_URL, payload, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            return data;
        },
    });
};


export const useAddVenderRegistration = () => {
    return useMutation({
        mutationFn: async (payload) => {
            const API_URL = `${NIGHT_EYE_API_URL}shop/setShopDetail`;

            // ✅ If payload is already FormData, send directly
            let formData;
            if (payload instanceof FormData) {
                formData = payload;
            } else {
                // Otherwise build a FormData object
                formData = new FormData();
                Object.entries(payload).forEach(([key, value]) => {
                    if (value !== null && value !== undefined) {
                        if (typeof value === "object" && !(value instanceof File)) {
                            formData.append(key, JSON.stringify(value)); // serialize objects/arrays
                        } else {
                            formData.append(key, value);
                        }
                    }
                });
            }

            const { data } = await axiosInstance.post(API_URL, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return data;
        },
    });
};
export const useAddVenderDetails = () => {
    return useMutation({
        mutationFn: async (payload) => {
            const API_URL = `${NIGHT_EYE_API_URL}shop/setShopUserDetail`;

            // ✅ If payload is already FormData, send directly
            let formData;
            if (payload instanceof FormData) {
                formData = payload;
            } else {
                // Otherwise build a FormData object
                formData = new FormData();
                Object.entries(payload).forEach(([key, value]) => {
                    if (value !== null && value !== undefined) {
                        if (typeof value === "object" && !(value instanceof File)) {
                            formData.append(key, JSON.stringify(value)); // serialize objects/arrays
                        } else {
                            formData.append(key, value);
                        }
                    }
                });
            }

            const { data } = await axiosInstance.post(API_URL, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return data;
        },
    });
};

export const useAddShopOwnerShipDetail = () => {
    return useMutation({
        mutationFn: async (payload) => {
            const API_URL = `${NIGHT_EYE_API_URL}shop/setShopOwnerShipDetail`;

            // ✅ If payload is already FormData, send directly
            let formData;
            if (payload instanceof FormData) {
                formData = payload;
            } else {
                // Otherwise build a FormData object
                formData = new FormData();
                Object.entries(payload).forEach(([key, value]) => {
                    if (value !== null && value !== undefined) {
                        if (typeof value === "object" && !(value instanceof File)) {
                            formData.append(key, JSON.stringify(value)); // serialize objects/arrays
                        } else {
                            formData.append(key, value);
                        }
                    }
                });
            }

            const { data } = await axiosInstance.post(API_URL, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return data;
        },
    });
};


export const useRemoveShopHelperDetails = () => {
    return useMutation({
        mutationFn: async (payload) => {
            const API_URL = `${NIGHT_EYE_API_URL}shop/removeShopHelperDetail
`;
            const { data } = await axiosInstance.post(API_URL, payload, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            return data;
        },
    });
};